import SessionEventProto from "../session-event-proto"
import Team from "../../model2/team/team"
import {SessionEventTeamHeader} from "./@type"

export default class SessionEvent_TeamNew extends SessionEventProto {

    private header: SessionEventTeamHeader

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            team            : sessionEvent.team,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        gd.session.teams.addFromJson(this.data)

        gd.modelBus.newUpdate('team', this.method, this.header.team.id, this.data, this.header);
    }
}